import { Icon, Input } from 'antd';
import classNames from 'classnames';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Route, useLocation, useParams } from 'react-router-dom';
import DispexButton from '../../../../components/DispexButton/DispexButton';
import useDebouncedSearch from '../../../../hooks/useDebouncedSearch';
import useSearchParamsState from '../../../../hooks/useSearchParamsState';
import { setExpandAllAction } from '../../store/actions/actions';
import ContractorModal from '../modals/contractorModal/ContractorModal/ContractorModal';
import DownloadReportModal from '../modals/DownloadReportModal/DownloadReportModal';
import FacilityModal from '../modals/facilityModal/FacilityModal/FacilityModal';
import styles from './Header.module.scss';

const Header = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const userCanCreate = useSelector(
    (store) => store.authentication.userInfo.CanCreateOffice
  );
  const [isAddFacilityModalVisible, setIsAddFacilityModalVisible] =
    useState(false);
  const [isAddCounterpartyModalVisible, setIsAddCounterpartyModalVisible] =
    useState(false);
  const [isDownloadReportModalVisible, setIsDownloadReportModalVisible] =
    useState(false);
  const [_searchParam, setSearchParam] = useSearchParamsState('search', '');
  const [search, setSearch, debouncedSearch] = useDebouncedSearch();
  useEffect(() => setSearchParam(debouncedSearch), [debouncedSearch]);
  useEffect(() => {
    setSearch();
  }, [location.pathname]);

  const expandedAllRows = useSelector(
    (store) => store.officesStore.expandAllRows
  );
  const clickAddCounterparty = () => {
    setIsAddCounterpartyModalVisible(true);
  };
  const clickCloseAddCounterpartyModal = () => {
    setIsAddCounterpartyModalVisible(false);
  };

  const clickAddFacility = () => {
    setIsAddFacilityModalVisible(true);
  };
  const clickDownloadReport = useCallback(
    () => setIsDownloadReportModalVisible(true),
    []
  );
  const closeDownloadReport = useCallback(
    () => setIsDownloadReportModalVisible(false),
    []
  );
  const clickCloseAddFacilityModal = () => {
    setIsAddFacilityModalVisible(false);
  };
  const clickSubmitAddFacility = useCallback(() => {
    setIsAddFacilityModalVisible(false);
  }, []);

  const onOpenAllRoomsChange = useCallback(() => {
    dispatch(setExpandAllAction(!expandedAllRows));
  }, [expandedAllRows]);

  const onInputChange = useCallback((e) => setSearch(e.target.value));

  return (
    <div className={styles.header}>
      <div className={styles.tabs}>
        <Link to="/Offices/facilities">
          <DispexButton
            className={classNames(styles.button, styles.tabsButton, {
              [styles.active]: params.officesTab === 'facilities',
            })}
          >
            Объекты
          </DispexButton>
        </Link>
        <Link to="/Offices/counterparties">
          <DispexButton
            className={classNames(styles.button, styles.tabsButton, {
              [styles.active]: params.officesTab === 'counterparties',
            })}
          >
            Контрагенты
          </DispexButton>
        </Link>
        <Link to="/Offices/meters">
          <DispexButton
            className={classNames(styles.button, styles.tabsButton, {
              [styles.active]: params.officesTab === 'meters',
            })}
          >
            Счетчики
          </DispexButton>
        </Link>
      </div>

      <div className={styles.rightHeaderSide}>
        <Route
          exact
          path={[
            '/Offices/facilities',
            '/Offices/counterparties',
            '/Offices/meters',
          ]}
        >
          <Input
            onChange={onInputChange}
            value={search}
            className={styles.input}
            placeholder="Поиск"
            suffix={<Icon type="search" />}
          />
        </Route>
        {params.officesTab === 'meters' && (
          <>
            <DispexButton
              className={styles.rounded}
              invert={true}
              type="secondary"
              onClick={onOpenAllRoomsChange}
            >
              {expandedAllRows ? 'Свернуть' : 'Раскрыть'} все помещения
            </DispexButton>
          </>
        )}
        {params.officesTab === 'facilities' && (
          <>
            <DispexButton
              className={styles.rounded}
              type="secondary"
              invert={true}
              onClick={clickDownloadReport}
            >
              Выгрузка квитанций
            </DispexButton>
            {userCanCreate && (
              <DispexButton
                className={classNames(styles.button, styles.rounded)}
                type="secondary"
                onClick={clickAddFacility}
              >
                Добавить объект <Icon type="plus" />
              </DispexButton>
            )}
          </>
        )}
        {params.officesTab === 'counterparties' && userCanCreate && (
          <DispexButton
            className={classNames(styles.button, styles.rounded)}
            type="secondary"
            onClick={clickAddCounterparty}
          >
            Добавить контрагента <Icon type="plus" />
          </DispexButton>
        )}
      </div>
      {isAddFacilityModalVisible && (
        <FacilityModal
          visible={isAddFacilityModalVisible}
          onCancel={clickCloseAddFacilityModal}
          onOk={clickSubmitAddFacility}
        />
      )}
      {isAddCounterpartyModalVisible && (
        <ContractorModal
          visible={isAddCounterpartyModalVisible}
          onCancel={clickCloseAddCounterpartyModal}
        />
      )}
      {isDownloadReportModalVisible && (
        <DownloadReportModal
          visible={isDownloadReportModalVisible}
          onClose={closeDownloadReport}
        />
      )}
    </div>
  );
};

export default memo(Header);
